$(document).ready(function(){

	var cookiesVal = sessionStorage.getItem('cookiesAlert');

	if (cookiesVal !== 'false') {
		$('.cookies__wrapper').animate({
			'opacity': 1,
			'bottom': 0,
		},'fast');
	} else {
		$('.cookies__wrapper').animate({
			'opacity': 0,
			'bottom': -100,
		},'fast');
	}

	$('.close__cookies').on('click', function(){
		// $('.cookies__wrapper').fadeOut('fast');
		$('.cookies__wrapper').animate({
			'opacity': 0,
			'bottom': -100,
		},'fast');
		sessionStorage.setItem('cookiesAlert','false');
	});
	
});